module.exports = __webpack_public_path__ + "img/feature3.80aa23ca.png";